import ListingPage from '../../components/ListingPage';
import SurveysCards from '../../components/Surveys/SurveysCards';

const SurveysPage = () => {
  return (
    <ListingPage
      createRestrictionKey="surveysCreate"
      entityType="survey"
      useStats={true}
      filterBy="name"
      Cards={SurveysCards}
    />
  );
};

export default SurveysPage;
